import { Document } from 'actions/documents';
import { ApplicationType } from 'enums/ApplicationType';
import { BorrowerType } from 'enums/BorrowerType';
import { DocumentCategory } from 'enums/DocumentCategory';
import { DocumentPrefix } from 'enums/DocumentPrefix';
import { DocumentStatus } from 'enums/DocumentStatus';

import { ApplicationDto } from '../api/ApplicationApi';
import { getFileExtension } from './fileHelper';

const MAX_AMOUNT_OF_MULTIPLE_DOCUMENTS = 6;
export const BORROWER_DOCUMENTS = [
  DocumentPrefix.BorrowerW2,
  DocumentPrefix.BorrowerPayStubs,
  DocumentPrefix.Borrower2ndMostRecentPayStubs,
  DocumentPrefix.BorrowerPersonalTaxReturns,
  DocumentPrefix.Borrower2ndMostRecentPersonalTaxReturns,
  DocumentPrefix.BorrowerBusinessTaxReturns,
  DocumentPrefix.Borrower2ndMostRecentBusinessTaxReturns,
  DocumentPrefix.BorrowerVADisabilityAwardsLetter,
  DocumentPrefix.BorrowerMilitaryPensionAwardsLetter,
  DocumentPrefix.BorrowerSocialSecurityAwardsLetter,
  DocumentPrefix.BorrowerEmployerPensionLetter,
  DocumentPrefix.BorrowerRentalOrLeaseAgreement,
  DocumentPrefix.Borrower1099,
  DocumentPrefix.BorrowerProfitAndLoss,
  DocumentPrefix.BorrowerTaxReturnExtension,
  DocumentPrefix.BorrowerDriversLicense,
  DocumentPrefix.BorrowerPassport,
  DocumentPrefix.BorrowerSocialSecurityCard,
  DocumentPrefix.BorrowerGreenCard,
  DocumentPrefix.BorrowerMonthlyMortgageStatement,
  DocumentPrefix.BorrowerClosingDisclosure,
  DocumentPrefix.BorrowerDeed,
  DocumentPrefix.BorrowerUtilityBill,
  DocumentPrefix.BorrowerHomeImprovementEstimatesOrContracts,
  DocumentPrefix.BorrowerVoidedCheck,
  DocumentPrefix.BorrowerScreenshotOfOnlineBanking,
  DocumentPrefix.BorrowerDirectDepositAuthorizationForm,
  DocumentPrefix.BorrowerLetterOfExplanation,
  DocumentPrefix.OtherDocument1,
  DocumentPrefix.OtherDocument2,
  DocumentPrefix.OtherDocument3,
  DocumentPrefix.OtherDocument4,
  DocumentPrefix.OtherDocument5,
  DocumentPrefix.OtherDocument6,
  DocumentPrefix.OtherDocument7,
  DocumentPrefix.OtherDocument8,
  DocumentPrefix.OtherDocument9,
  DocumentPrefix.OtherDocument10,
  DocumentPrefix.BorrowerOtherIncome1,
  DocumentPrefix.BorrowerOtherIncome2,
  DocumentPrefix.BorrowerOtherIncome3,
  DocumentPrefix.BorrowerOtherIncome4,
  DocumentPrefix.BorrowerOtherIncome5,
  DocumentPrefix.BorrowerOtherIncome6,
  DocumentPrefix.OtherFundingDocument,
  DocumentPrefix.OtherFundingDocument2,
  DocumentPrefix.OtherFundingDocument3,
  DocumentPrefix.OtherContractorDocument,
  DocumentPrefix.OtherContractorDocument2,
  DocumentPrefix.OtherContractorDocument3,
  DocumentPrefix.OtherHomeVerificationDocument,
  DocumentPrefix.OtherHomeVerificationDocument2,
  DocumentPrefix.OtherHomeVerificationDocument3,
  DocumentPrefix.BorrowerOtherIDDocument,
  DocumentPrefix.BorrowerOtherIDDocument2,
  DocumentPrefix.BorrowerOtherIDDocument3,
  DocumentPrefix.BorrowerMiscOtherDocument1,
  DocumentPrefix.BorrowerMiscOtherDocument2,
  DocumentPrefix.BorrowerMiscOtherDocument3,
  DocumentPrefix.BorrowerBankStatement,
  DocumentPrefix.BorrowerCellPhoneBill,
];

export const COBORROWER_DOCUMENTS = [
  ...BORROWER_DOCUMENTS,
  DocumentPrefix.CoborrowerW2,
  DocumentPrefix.CoborrowerPayStubs,
  DocumentPrefix.Coborrower2ndMostRecentPayStubs,
  DocumentPrefix.CoborrowerPersonalTaxReturns,
  DocumentPrefix.Coborrower2ndMostRecentPersonalTaxReturns,
  DocumentPrefix.CoborrowerBusinessTaxReturns,
  DocumentPrefix.Coborrower2ndMostRecentBusinessTaxReturns,
  DocumentPrefix.CoborrowerVADisabilityAwardsLetter,
  DocumentPrefix.CoborrowerMilitaryPensionAwardsLetter,
  DocumentPrefix.CoborrowerSocialSecurityAwardsLetter,
  DocumentPrefix.CoborrowerEmployerPensionLetter,
  DocumentPrefix.CoborrowerRentalOrLeaseAgreement,
  DocumentPrefix.Coborrower1099,
  DocumentPrefix.CoborrowerProfitAndLoss,
  DocumentPrefix.CoborrowerTaxReturnExtension,
  DocumentPrefix.CoborrowerDriversLicense,
  DocumentPrefix.CoborrowerPassport,
  DocumentPrefix.CoborrowerSocialSecurityCard,
  DocumentPrefix.CoborrowerGreenCard,
  DocumentPrefix.CoborrowerLetterOfExplanation,
  DocumentPrefix.CoborrowerOtherIncome1,
  DocumentPrefix.CoborrowerOtherIncome2,
  DocumentPrefix.CoborrowerOtherIncome3,
  DocumentPrefix.CoborrowerOtherIncome4,
  DocumentPrefix.CoborrowerOtherIncome5,
  DocumentPrefix.CoborrowerOtherIncome6,
  DocumentPrefix.CoborrowerOtherIDDocument,
  DocumentPrefix.CoborrowerOtherIDDocument2,
  DocumentPrefix.CoborrowerOtherIDDocument3,
  DocumentPrefix.CoborrowerMiscOtherDocument1,
  DocumentPrefix.CoborrowerMiscOtherDocument2,
  DocumentPrefix.CoborrowerMiscOtherDocument3,
  DocumentPrefix.CoBorrowerCellPhoneBill,
];

export const MULTIPLE_DOCUMENTS_PREFIXES = [
  DocumentPrefix.BorrowerW2,
  DocumentPrefix.CoborrowerW2,
  DocumentPrefix.BorrowerPayStubs,
  DocumentPrefix.CoborrowerPayStubs,
  DocumentPrefix.Borrower2ndMostRecentPayStubs,
  DocumentPrefix.Coborrower2ndMostRecentPayStubs,
  DocumentPrefix.BorrowerPersonalTaxReturns,
  DocumentPrefix.CoborrowerPersonalTaxReturns,
  DocumentPrefix.Borrower2ndMostRecentPersonalTaxReturns,
  DocumentPrefix.Coborrower2ndMostRecentPersonalTaxReturns,
  DocumentPrefix.BorrowerBusinessTaxReturns,
  DocumentPrefix.CoborrowerBusinessTaxReturns,
  DocumentPrefix.Borrower2ndMostRecentBusinessTaxReturns,
  DocumentPrefix.Coborrower2ndMostRecentBusinessTaxReturns,
  DocumentPrefix.BorrowerProfitAndLoss,
  DocumentPrefix.CoborrowerProfitAndLoss,
  DocumentPrefix.BorrowerVADisabilityAwardsLetter,
  DocumentPrefix.CoborrowerVADisabilityAwardsLetter,
  DocumentPrefix.BorrowerSocialSecurityAwardsLetter,
  DocumentPrefix.CoborrowerSocialSecurityAwardsLetter,
  DocumentPrefix.BorrowerRentalOrLeaseAgreement,
  DocumentPrefix.CoborrowerRentalOrLeaseAgreement,
  DocumentPrefix.BorrowerEmployerPensionLetter,
  DocumentPrefix.CoborrowerEmployerPensionLetter,
  DocumentPrefix.BorrowerMilitaryPensionAwardsLetter,
  DocumentPrefix.CoborrowerMilitaryPensionAwardsLetter,
];

export const NOT_BORROWER_DOCUMENT_CATEGORIES = [
  DocumentCategory.ContractorWorkOrder,
  DocumentCategory.HomeVerification,
  DocumentCategory.Funding,
];

export const getIsDocumentRequired = (prefix: DocumentPrefix, counterSuffix: string) => {
  return `${prefix}_required` + counterSuffix;
};

export const getDocumentStatus = (prefix: DocumentPrefix, counterSuffix: string) => {
  return `${prefix}_status` + counterSuffix;
};

export const getDocumentCategory = (prefix: DocumentPrefix, counterSuffix: string) => {
  return `${prefix}_category` + counterSuffix;
};

const getDocumentName = (prefix: DocumentPrefix, counterSuffix: string) => {
  return `${prefix}_name` + counterSuffix;
};

export const modifyDocumentsNames = (
  requiredDocuments: Document[],
  borrowerFirstName?: string | null,
  coborrowerFirstName?: string | null,
) => {
  return requiredDocuments.map((document) => {
    if (document.category.startsWith('Borrower')) {
      return { ...document, name: `${borrowerFirstName}'s ${document.name}` };
    }

    if (document.category.startsWith('Coborrower')) {
      return { ...document, name: `${coborrowerFirstName}'s ${document.name}` };
    }

    return { ...document };
  });
};

export const getRequiredDocuments = (
  application: ApplicationDto,
  borrowerFirstName: string,
  coBorrowerFirstName: string,
  applicationType: ApplicationType,
): Document[] => {
  const documentsList = applicationType === ApplicationType.Individual ? BORROWER_DOCUMENTS : COBORROWER_DOCUMENTS;

  const documents = documentsList.reduce((accumulator: Document[], prefix) => {
    const documentsAmount = MULTIPLE_DOCUMENTS_PREFIXES.includes(prefix) ? MAX_AMOUNT_OF_MULTIPLE_DOCUMENTS : 1;

    for (let index = 1; index <= documentsAmount; index++) {
      const counterSuffix = index === 1 ? '' : `_${index}`;

      const required = application.variables[getIsDocumentRequired(prefix, counterSuffix)];
      const name = application.variables[getDocumentName(prefix, counterSuffix)] as string;
      const status = application.variables[getDocumentStatus(prefix, counterSuffix)] as DocumentStatus;
      const category = application.variables[getDocumentCategory(prefix, counterSuffix)] as DocumentCategory;

      if (required && name && category) {
        accumulator.push({
          header: getDocumentName(prefix, counterSuffix),
          name,
          category,
          status: status ? status : DocumentStatus.Upload,
        });
      }
    }

    return accumulator;
  }, []);

  return modifyDocumentsNames(documents, borrowerFirstName, coBorrowerFirstName);
};

export const getDocumentFullName = (
  file: File,
  documentHeader: string,
  documentCategory: DocumentCategory,
  borrowerFullName: string,
) => {
  const fileExtension = getFileExtension(file.name).toLowerCase();
  const titleWithUnderscores = documentHeader.trim().split(/[ /]/).join('_');
  const categoryPart = documentCategory ? `${documentCategory.trim().split(' ').join('_')}_` : '';

  return `${categoryPart}${borrowerFullName}_${titleWithUnderscores}.${fileExtension}`;
};

export const getBorrowerNameForDocument = (firstName: string, lastName: string) => {
  return `${firstName}_${lastName}`;
};

export const getCountBorrowerRequiredDocuments = (documents: Document[], borrowerType: BorrowerType) => {
  return documents.reduce(
    (acc, document) =>
      document.status === DocumentStatus.Upload &&
      !NOT_BORROWER_DOCUMENT_CATEGORIES.includes(document.category as DocumentCategory) &&
      document.header.startsWith(borrowerType.toLowerCase())
        ? ++acc
        : acc,
    0,
  );
};

export const isRequiredDocumentsBelongsToCategory = (documents: Document[], category: DocumentCategory) => {
  return documents.some((document) => document.category === category);
};

export const getCountNotCompletedRequiredDocuments = (documents: Document[], category: DocumentCategory) => {
  return documents.reduce(
    (acc, document) => (document.status === DocumentStatus.Upload && document.category === category ? ++acc : acc),
    0,
  );
};

export const splitIntoCategories = (documents: Document[]) => {
  return Object.values(DocumentCategory).reduce((accumulator, key) => {
    const documentsWithKey = documents.filter((document) => document.category === key);

    return { ...accumulator, ...(documentsWithKey.length > 0 && { [key]: documentsWithKey }) };
  }, {});
};

export const getDocumentsByCategory = (documents: Document[], category: DocumentCategory): Document[] => {
  return documents.filter((document) => (document.category as DocumentCategory) === category);
};

export const isDocumentCategoryCompleted = (documents: Document[], category: DocumentCategory): boolean => {
  const requiredDocuments = splitIntoCategories(documents)[category];

  if (!requiredDocuments) {
    return true;
  }

  const documentCategoryNotCompleted = requiredDocuments.some(
    (document: Document) => document.status === DocumentStatus.Upload,
  );

  return !documentCategoryNotCompleted;
};

export const isDocumentCategoryRequired = (documents: Document[], category: DocumentCategory): boolean => {
  const requiredDocuments = splitIntoCategories(documents)[category];

  return !!requiredDocuments?.length;
};
